import { render, staticRenderFns } from "./MensagemAlerta.vue?vue&type=template&id=dc6cdd96&scoped=true&"
import script from "./MensagemAlerta.vue?vue&type=script&lang=js&"
export * from "./MensagemAlerta.vue?vue&type=script&lang=js&"
import style0 from "./MensagemAlerta.vue?vue&type=style&index=0&id=dc6cdd96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6cdd96",
  null
  
)

export default component.exports